import { render } from "./RegionDashboardsRepresentativeAbroadBaseInfo.vue?vue&type=template&id=be1be5b8&scoped=true&ts=true"
import script from "./RegionDashboardsRepresentativeAbroadBaseInfo.vue?vue&type=script&lang=ts"
export * from "./RegionDashboardsRepresentativeAbroadBaseInfo.vue?vue&type=script&lang=ts"

import "./RegionDashboardsRepresentativeAbroadBaseInfo.vue?vue&type=style&index=0&id=be1be5b8&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be1be5b8"]])

export default __exports__